import {remCalc} from '_themeUtils'

const menuItem = {
    MenuItem: {
        baseStyle: () => ({
            linkWrapper: {
                gap: 'spacing.1',
                alignItems: 'center',
                justifyContent: 'flex-start',
                cursor: 'pointer',
                w: 'full',
            },
            linkText: {
                pos: 'relative',
                textStyle: 'paragraphSm',
                color: 'color.text.grey.600',
                fontWeight: {base: 400, lg: 300},
                letterSpacing: remCalc(0.8),
                transition: 'all .15s ease-in-out',
                textAlign: 'left',
                _after: {
                    content: '""',
                    pos: 'absolute',
                    width: '100%',
                    h: remCalc(1),
                    opacity: 0,
                    bottom: '-spacing.0.5',
                    left: 0,
                    transition: 'all .15s ease-in-out',
                    bg: 'color.background.transparent',
                },
                _hover: {
                    color: 'color.text.black',
                    _after: {
                        opacity: 1,
                        bg: {base: 'color.background.transparent', lg: 'color.background.black'},
                    },
                },
            },
            mobileWrapper: {
                w: 'full',
                position: 'relative',
            },
            arrowContainer: {
                position: 'absolute',
                top: 'auto',
            },
            arrowLeft: {
                left: 0,
            },
            arrowRight: {
                right: 0,
            },
            centerText: {
                textStyle: 'paragraphSm',
                fontWeight: 500,
                margin: 'auto',
            },
            leftText: {
                marginLeft: 0,
            },
        }),
        variants: {
            header: ({colorMode, hasPadding, hasInlineBlock}: {colorMode: 'dark' | 'light'; hasPadding: boolean; hasInlineBlock: boolean}) => ({
                linkWrapper: {
                    w: {base: hasInlineBlock ? 'auto' : 'full', lg: 'max-content'},
                    gap: 'spacing.1',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    cursor: 'pointer',
                    display: {base: hasInlineBlock ? 'inline-block' : 'flex', lg: 'flex'},
                    verticalAlign: hasInlineBlock ? 'top' : 'middle',
                },
                linkText: {
                    color: {base: 'color.text.black', xl: colorMode === 'light' ? 'color.text.white' : 'color.text.black'},
                    textStyle: 'paragraphXs',
                    letterSpacing: {base: remCalc(3), md: remCalc(1.5), xl: remCalc(3)},
                    fontWeight: 400,
                    // textTransform: 'uppercase',
                    textAlign: 'center',
                    py: {base: hasPadding ? 'spacing.5' : '0', lg: 'spacing.4'},
                    px: {lg: hasPadding ? 'spacing.1' : '0', xl: 'spacing.3'},
                    lineHeight: {base: hasInlineBlock ? remCalc(17) : remCalc(14), lg: remCalc(14)},
                },
            }),
            title: {
                linkText: {
                    color: 'color.text.black',
                    textStyle: {base: 'paragraphSm', lg: 'paragraphXs'},
                    letterSpacing: remCalc(3),
                    fontWeight: 500,
                    textTransform: 'uppercase',
                },
            },
            ideaSuggestion: {
                linkWrapper: {
                    w: 'fit-content',
                },
                linkText: {
                    color: 'color.text.black',
                    textStyle: 'paragraphSm',
                },
            },
            genderSuggestion: {
                linkWrapper: {
                    w: 'fit-content',
                },
                linkText: {
                    textStyle: 'paragraphSm',
                },
            },
        },
    },
}

export default menuItem
